export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "checking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vérification de vos photos en cours…"])},
        "warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Photos non conformes : cela pourra vous être préjudiciable en cas de sinistre."])},
        "missing_faces": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Il manque : ", _interpolate(_named("faces")), "."])},
        "warning_help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remplacez-les ou enregistrez quand même."])}
      },
      "en": {
        "checking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Checking your photos…"])},
        "warning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non-compliant photos: this may count against you if you file a claim."])},
        "missing_faces": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Missing: ", _interpolate(_named("faces")), "."])},
        "warning_help": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Replace them or register anyway."])}
      }
    }
  })
}
